export default class ProfileSaveResponse {
    state = null
    success = false

    constructor(response) {
        if (!response || response.errors || !response.data) {
            return
        }

        if (response.data.success) {
            this.state = response.data.state
            this.success = true
        }
    }
}